export default String.raw`
.header-top-bar {
    justify-content: flex-end;
    padding: 8px 32px;
    &__side:first-child {
        display: none;
    }
}

.header {
    &:not(.fixed) {
        border-bottom: 1px solid #E7E7E7;
    }
    &.sticky {
        .header {
            &__main {
                grid-template-columns: auto auto minmax(0, 1fr) auto;
            }
            &__logo {
                grid-column: 2;
                margin: 0 0 0 32px;
            }
            &__menu {
                grid-row: 1;
                grid-column: 1;
            }
            &__search:not(.header__categories-search) {
                grid-row: 1;
                grid-column: 3;
                margin: 8px auto;
            }
        }
        .header-client-area {
            grid-column: 4;
            &__btn {
                min-width: unset;
                &-text, &-price {
                    display: none;
                }
            }
        }
    }
    &:not(.closed) {
        .header__logo {
            padding-left: 0;
        }
        .header-client-area {
            padding-right: 0;
        }
    }
    &__main {
        padding: 8px 32px;
        &.closed {
            flex-direction: row-reverse;
            justify-content: flex-end;
            .header__logo {
                flex-grow: 1;
                display: flex;
                justify-content: center;
                a {
                    width: fit-content;
                }
            }
            .header-nav__list > li:first-child .header-nav__btn {
                padding-left: 24px;
            }
        }
    }
    &__menu {
        width: fit-content;
        display: block;
        grid-row: 2;
        grid-column: 1;
        cursor: pointer;
    }
    &__search:not(.header__categories-search) {
        grid-row: 2;
        grid-column: 1 / 3;
        max-width: calc(100% - 64px);
        margin: 8px 0 16px auto;
    }
    .header-nav {
        display: none;
        &__list {
            flex-direction: column;
            align-items: flex-start;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(231, 231, 231, 0.91);
            & > li {
                width: 100%;
                &:first-child .header-nav__btn {
                    padding: 8px 24px;
                }
            }
        }
        &__btn {
            padding: 8px 24px;
            justify-content: space-between;
            font-weight: 500;
            &:hover {
                border-color: transparent;
            }
            &-icon {
                display: none;
            }
            &::after, &::before {
                display: none;
            }
        }
        &__mobile-icon {
            display: block;
            transform: rotate(-90deg);
            padding: 4px;
        }
    }

    .header-menu {
        &__content {
            border-top: 1px solid rgba(231, 231, 231, 0.91);
            max-width: 100%;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            width: 360px;
            overflow-y: auto;
        }
        &__contact {
            padding: 16px 24px 8px;
        }
        &__item {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: $primaryColorFont;
            margin-bottom: 4px;
            svg {
                margin-right: 8px;
            }
            &.text {
                font-weight: 400;
            }
            &.supervisor {
                @include body-1-semi-bold;
                cursor: pointer;
            }
        }
        &__box-supervisor {
            margin-top: 16px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }
}

.header-categories {
    &__btn {
        &.menu {
        display: flex;
        & ~ .header__search {
            grid-row: 2;
            grid-column: 1 / 3;
            margin-top: 16px;
            max-width: none;
        }
        }
    }
}
`